import { InjectionToken } from '@angular/core';
import { PageResolver } from 'src/app/core/interfaces/page-resolver.interface';
import { PrefetchHandler } from 'src/app/core/interfaces/prefetch-handler.interface';

export const PAGE_DATA = new InjectionToken<any>('PAGE_DATA');
export const IS_BUILDER_EDITOR = new InjectionToken<boolean>('IS_BUILDER_EDITOR');
